module.exports = __webpack_public_path__ + "static/media/officialogo.35e1f13b.png";